import request from "../../helpers/request"

export const getModuloByCentral = async (idCentral: string) => {
  const url = `${process.env.REACT_APP_API}/DispModulo/GetbyIdCentral/${idCentral}`
  const result =  await request({ url })
  return result.data
}